angular.module("appVersion", [])
.constant("version", "4.57.2026043-0.1");
